import React, { Component } from 'react';
import './Select.scss';


class Select extends Component{

    constructor(props){
        super(props);
        this.select = React.createRef();
    }
    
    componentDidMount(){
        this.init();
        document.addEventListener("click", ()=>{
            this.closeAllSelect();
        });
    }
    componentDidUpdate(){
        this.init();
    }
    render(){
        return (<>
            <div className={`custom-select ${this.props.className}`} ref={this.select} onClick={(e)=>{
                e.stopPropagation();
            }}>
                <select defaultValue={this.props.selected} >
                    <option></option>
                    {this.props.options.map(_=>{
                        return(
                            <option selected={_.name === this.props.selected || _.value === this.props.selected} key={_.value} value={_.value}>{_.name}</option>
                        )
                    })}
                </select>
            </div>
        </>)
    }

    init(){
        const that = this;
        var x, i, j, l, ll, selElmnt, a, b, c;
        /*look for any elements with the class "custom-select":*/
        x = this.select.current;
        const t1 = x.getElementsByClassName("select-selected");
        const t2 = x.getElementsByClassName("select-items");

        selElmnt = x.getElementsByTagName("select")[0];

        if(selElmnt && selElmnt.selectedIndex > -1){
            const bottomSpace = document.body.offsetHeight - x.offsetTop;
            if(bottomSpace < 300 && this.props.openTop !== false){
                x.setAttribute('open-top', null)
            }

            ll = selElmnt.length;
            /*for each element, create a new DIV that will act as the selected item:*/
            if(t1.length){
                a = t1[0]
                a.innerHTML = "";
            }else{
                a = document.createElement("DIV");
                a.setAttribute("class", "select-selected");
                a.setAttribute("data-label", this.props.label)
                a.addEventListener("click", function(e) {
                    /*when the select box is clicked, close any other select boxes,
                    and open/close the current select box:*/
                    e.stopPropagation();
                    that.closeAllSelect(this);
                    this.nextSibling.classList.toggle("select-hide");
                });
            }
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex]?.innerHTML;
            if(!a.innerHTML){
                a.setAttribute("none-selected",null)
            }else{
                a.removeAttribute("none-selected");
            }


            x.appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            if(t2.length){
                b = t2[0];
                b.innerHTML = "";
            }else{
                b = document.createElement("DIV");
                b.setAttribute("class", "select-items select-hide");
            }
            for (j = 1; j < ll; j++) {
                /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
                c = document.createElement("DIV");
                c.setAttribute('title',selElmnt.options[j].innerHTML)
                c.innerHTML = selElmnt.options[j].innerHTML;
                c.addEventListener("click", function(e) {
                    /*when an item is clicked, update the original select box,
                    and the selected item:*/
                    var y, i, k, s, h, sl, yl;
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    sl = s.length;
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < sl; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {

                            if(that.props.onChange){
                                const temp = that.props.options.find(_=>_.name == this.innerHTML)
                                that.props.onChange(temp);
                            }
                            
                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            if(h.innerHTML){
                                h.removeAttribute("none-selected")
                            }
                            if(this.parentNode){
                                y = this.parentNode.getElementsByClassName("same-as-selected");
                                yl = y.length;
                                for (k = 0; k < yl; k++) {
                                    y[k].removeAttribute("class");
                                }
                            }
                            
                            this.setAttribute("class", "same-as-selected");
                            break;
                        }
                    }
                    h.click();
                });
                b.appendChild(c);
            }
            x.appendChild(b);
        }
        
    }

    closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
    }
}

Select.defaultProps = {
    openTop: true
}
export default Select;